import type {
  MinimumAdapterInterface,
  normalize,
} from '@ember-data/legacy-compat';
import { setBuildURLConfig } from '@ember-data/json-api/request';
import { useLegacyStore } from '@warp-drive/legacy';
import { JSONAPICache } from '@warp-drive/json-api';
import { HOST } from 'scaleflow/adapters/application';
import AuthHandler from 'scaleflow/handlers/auth';
import ModelTypesHandler from 'scaleflow/handlers/model-types';

setBuildURLConfig({ host: HOST, namespace: '' });

export default class StoreService extends useLegacyStore({
  linksMode: false,
  legacyRequests: true,
  cache: JSONAPICache,
  handlers: (store) => [new ModelTypesHandler(), new AuthHandler(store)],
}) {
  // useLegacyStore implements the legacy methods, but its types leave them out.
  declare adapterFor: (modelName: string) => MinimumAdapterInterface;
  declare normalize: (
    ...args: Parameters<typeof normalize>
  ) => ReturnType<typeof normalize>;
}
